import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
    header: {
        height: 60,
        width: 960,
        maxWidth: "100%",
        // backgroundColor: "white",
        paddingLeft: "20px",
        paddingRight: "20px",
        position: "fixed",
        zIndex: 999,
      },
      wrapHeader: {
        display: "flex",
        padding: "15px 0",
        justifyContent: "space-between",
        alignItems: "center",
      },
      title: {
        color: "black",
        "@media (max-width: 480px)": {
            fontSize: 12,
            maxWidth: "150px",
          },
      },
      wrapIcon: {
        height: "100%",
        width: "20vh",
      },
      icCart: {
        color: "black",
      },
}))

export default useStyles
